import { toast } from 'material-react-toastify';
import { useTranslation } from 'react-i18next';

import { useDeleteInvoice } from '~/models/Invoices/hooks';
import { NotFoundError } from '~/types/error';

import { ConfirmationDialog } from '../ConfirmationDialog';

type Props = {
  id: string;
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
};

export const DeleteInvoiceDialog = ({ id, open, onClose, onSuccess }: Props) => {
  const { t } = useTranslation();
  const { mutateAsync, isLoading } = useDeleteInvoice({
    onSuccess: () => {
      toast.success(t('msg_success_invoice_deleted'));
      onClose();

      if (onSuccess) {
        onSuccess();
      }
    },
  });

  const onDelete = async () => {
    try {
      await mutateAsync(id);
    } catch (error) {
      if (error instanceof NotFoundError && error.detail) {
        toast.error(t(error.detail));
      }
    }
  };

  return (
    <ConfirmationDialog
      open={open}
      title={t('invoice_action_sheet_dialog_message')}
      onClose={onClose}
      actions={[
        {
          label: t('invoice_delete_action_sheet_yes'),
          color: 'error',
          onClick: onDelete,
          showIsLoading: true,
        },
        {
          label: t('invoice_delete_action_sheet_no'),
          onClick: onClose,
          color: 'inherit',
        },
      ]}
      isLoading={isLoading}
    />
  );
};
